import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isEmbargoedCountry } from '../util/dataHelpers';
import { TRIALS_ENABLED } from '../../util/config';

function getLicenseData(tenantLicenses) {
  const licenses = !tenantLicenses
    ? []
    : tenantLicenses.sort((a, b) => {
        const x = a.startDate;
        const y = b.startDate;
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
      });

  return licenses.map((license) => {
    const startDate = new Date(license.startDate);
    const expDate = new Date(license.endDate);
    let status = license.licenseStatus;
    if (Date.now() - startDate < 0) {
      status = 'Future';
    }
    if (expDate - Date.now() < 0) {
      status = 'Expired';
    }

    return (
      <tr key={license.licenseKey}>
        <td>{license.licenseKey}</td>
        <td>{license.productShortCode}</td>
        <td>{license.qty}</td>
        <td>{status}</td>
        <td>{new Date(license.startDate).toLocaleDateString()}</td>
        <td>{new Date(license.endDate).toLocaleDateString()}</td>
      </tr>
    );
  });
}

function LicenseInfo() {
  const data = useAuth();

  if (!data || !data.tenant) {
    return null;
  }

  const items = getLicenseData(data.tenant.allLicenses);

  if (!items || items.length === 0) {
    // no history of any licenses are on record. offer a trial, if eligible.
    const isEmbargoed = isEmbargoedCountry(data?.tenant?.countryCode);

    return (
      <>
        You have no licenses
        <br />
        <br />
        {TRIALS_ENABLED && data?.trialRequested && (
          <>
            A trial has been requested for your tenant, and you should hear back
            soon. Please reach out to RealConnect_Trial@poly.com for further
            questions.
          </>
        )}
        {TRIALS_ENABLED && isEmbargoed && (
          <>
            Your organization is in an embargoed country [
            {data.tenant.countryCode}] and is not eligible for a trial.
          </>
        )}
        {TRIALS_ENABLED && !isEmbargoed && !data?.trialRequested && (
          <Link to="/request-trial">Click here to request a 60-day trial</Link>
        )}
      </>
    );
  }

  return (
    <>
      <table id="licensesTable" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>License Key</th>
            <th>Type</th>
            <th>Qty</th>
            <th>Status</th>
            <th>Begin</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody id="licensesTableBody">{items}</tbody>
      </table>
      <hr />
      <label htmlFor="totalLicenses">Call Licenses:</label>{' '}
      {data.tenant.totalLicenses}
      <br />
      <small>
        The number of concurrent VTC calls allowed into your tenant&apos;s
        online meetings.
      </small>
    </>
  );
}

export default LicenseInfo;
